import React from "react";
import CartItem from "../Componets/CartItem/CartItem";

const Cart = () => {
  return (
    <div>
      <CartItem />
    </div>
  );
};

export default Cart;
